import React, { useState } from "react";
import {
  FaWhatsapp,
  FaTimes,
  FaPaperPlane
} from "react-icons/fa";

import "./WhatsAppBot.css";

export default function WhatsAppBot() {

  /* =========================================================
     QUESTIONS
  ========================================================= */

  const questions = [

    `שלום 👋
אני הנציג הדיגיטלי של נצר הובלות ומנופים בע״מ!

אשאל אותך כמה שאלות קצרות
כדי להבין את הצורך שלך
ולחזור אליך עם פתרון מתאים.`,

    "איזה שירות אתה צריך?",

    "באיזו עיר מתבצעת העבודה?",

    "מה השם שלך?",

    "מה מספר הטלפון שלך?"
  ];


  /* =========================================================
     OPTIONS
  ========================================================= */

  const options = [

    [

      "הובלות מיוחדות",

      "הובלת ציוד כבד",

      "הובלת מכולות / קונטיינרים",

      "הובלת מבנים / קרוואנים / מיגוניות",

      "השכרת מנוף",

      "מנוף סל להשכרה",

      "מנוף זרוע להשכרה",

      "מנוף סל להרמת אדם",

      "השכרת סל הרמה",

      "הרמת זכוכית וציוד כבד",

      "אחר"

    ],

    [

      "הובלת מיגונית / ממ״ד נייד",

      "הובלת קרוואן",

      "העברת מבנה",

      "הרמת מבנה",

      "הובלת ציוד כבד",

      "הובלת חומרי בניין",

      "הובלת מכולה / קונטיינר",

      "הובלת עצים",

      "הובלת כספת כבדה",

      "הובלת מכונות כבדות",

      "פירוק והעברת מפעל",

      "הרמת זכוכית בוואקום",

      "הנפת זכוכית לגובה",

      "אחר"

    ]

  ];


  /* =========================================================
     STATES
  ========================================================= */

  const [open, setOpen] = useState(false);

  const [messages, setMessages] = useState([
    {
      type: "bot",
      text: questions[0]
    }
  ]);

  const [step, setStep] = useState(0);

  const [input, setInput] = useState("");

  const [answers, setAnswers] = useState([]);

  const [selectedOption, setSelectedOption] = useState(false);

  const [finished, setFinished] = useState(false);


  /* =========================================================
     SELECT OPTION
  ========================================================= */

  function selectOption(option) {

    setAnswers(prev => [
      ...prev,
      option
    ]);

    setMessages(prev => [
      ...prev,
      {
        type: "user",
        text: option
      }
    ]);

    setSelectedOption(true);


    if (step < questions.length - 1) {

      setTimeout(() => {

        const nextStep = step + 1;

        setMessages(prev => [
          ...prev,
          {
            type: "bot",
            text: questions[nextStep]
          }
        ]);

        setStep(nextStep);

        setSelectedOption(false);

      }, 500);

    }
  }


  /* =========================================================
     SEND MESSAGE
  ========================================================= */

  function sendMessage() {

    if (!input.trim()) return;


    /* אין input כאשר יש אפשרויות */
    if (options[step]) return;


    /* =====================================================
       CITY VALIDATION
    ===================================================== */

    if (step === 2) {

      const cityRegex =
        /^[א-תa-zA-Z\s\-]{2,}$/;

      if (!cityRegex.test(input.trim())) {

        setMessages(prev => [
          ...prev,
          {
            type: "bot",
            text: "❌ נא להזין שם עיר תקין."
          }
        ]);

        return;
      }
    }


    /* =====================================================
       NAME VALIDATION
    ===================================================== */

    if (step === 3) {

      const nameRegex =
        /^[א-תa-zA-Z\s\-]{2,}$/;

      if (!nameRegex.test(input.trim())) {

        setMessages(prev => [
          ...prev,
          {
            type: "bot",
            text: "❌ נא להזין שם תקין."
          }
        ]);

        return;
      }
    }


    /* =====================================================
       PHONE VALIDATION
    ===================================================== */

    if (step === 4) {

      const cleanPhone =
        input.replace(/\D/g, "");

      if (!/^05\d{8}$/.test(cleanPhone)) {

        setMessages(prev => [
          ...prev,
          {
            type: "bot",
            text:
              "❌ נא להזין מספר טלפון תקין.\nלדוגמה: 0501234567"
          }
        ]);

        return;
      }


      setAnswers(prev => [
        ...prev,
        cleanPhone
      ]);

      setMessages(prev => [
        ...prev,
        {
          type: "user",
          text: cleanPhone
        }
      ]);

      setInput("");

      setStep(questions.length);


      setTimeout(() => {

        setMessages(prev => [
          ...prev,
          {
            type: "bot",
            text:
              "🎉 מעולה!\n\nכל הפרטים התקבלו בהצלחה.\n\nלחץ על הכפתור למטה כדי לשלוח את הפנייה לנצר הובלות ומנופים בוואטסאפ."
          }
        ]);

        setFinished(true);

      }, 500);

      return;
    }


    /* =====================================================
       SAVE ANSWER
    ===================================================== */

    setAnswers(prev => [
      ...prev,
      input
    ]);

    setMessages(prev => [
      ...prev,
      {
        type: "user",
        text: input
      }
    ]);

    setInput("");


    /* =====================================================
       NEXT QUESTION
    ===================================================== */

    setTimeout(() => {

      const nextStep =
        step + 1;

      setMessages(prev => [
        ...prev,
        {
          type: "bot",
          text: questions[nextStep]
        }
      ]);

      setStep(nextStep);

    }, 500);
  }


  /* =========================================================
     SEND TO WHATSAPP
  ========================================================= */

  function sendWhatsapp() {

    const text = `
🚚 פנייה חדשה מהאתר
נצר הובלות ומנופים בע״מ

🔹 סוג השירות:
${answers[0] || ""}

🔹 סוג העבודה:
${answers[1] || ""}

🔹 עיר:
${answers[2] || ""}

🔹 שם:
${answers[3] || ""}

🔹 טלפון:
${answers[4] || ""}

אשמח לקבל פרטים נוספים והצעת מחיר.
`;


    window.open(
      `https://api.whatsapp.com/send?phone=972506615262&text=${encodeURIComponent(text)}`,
      "_blank"
    );


    setFinished(false);


    setMessages(prev => [
      ...prev,
      {
        type: "bot",
        text:
          "✅ תודה רבה!\n\nהפרטים שלך התקבלו בהצלחה.\nצוות נצר הובלות ומנופים יחזור אליך בהקדם."
      }
    ]);


    /* =====================================================
       RESET AFTER 30 SECONDS
    ===================================================== */

    setTimeout(() => {

      setStep(0);

      setAnswers([]);

      setInput("");

      setSelectedOption(false);

      setMessages([
        {
          type: "bot",
          text: questions[0]
        }
      ]);

    }, 30000);
  }


  /* =========================================================
     CLOSE CHAT
  ========================================================= */

  function closeChat() {
    setOpen(false);
  }


  /* =========================================================
     UI
  ========================================================= */

  return (
    <>

      {/* =====================================================
          FLOATING WHATSAPP BUTTON
      ===================================================== */}

      <button
        className="wa-button"
        onClick={() => setOpen(true)}
        aria-label="פתיחת צ׳אט וואטסאפ"
      >
        <FaWhatsapp />
      </button>


      {/* =====================================================
          CHAT
      ===================================================== */}

      {open && (

        <div className="chat">


          {/* =================================================
              HEADER
          ================================================= */}

          <div className="header2">

            <div className="logoArea">

              <img
                src="/logo193.jpeg"
                alt="נצר הובלות ומנופים"
              />

              <div className="company-name">

                <span>
                  נצר
                </span>

                <small>
                  הובלות ומנופים בע״מ
                </small>

              </div>

            </div>


            <button
              onClick={closeChat}
              aria-label="סגירת צ׳אט"
            >
              <FaTimes />
            </button>

          </div>


          {/* =================================================
              MESSAGES
          ================================================= */}

          <div className="messages">

            {messages.map((msg, i) => (

              <div
                key={i}
                className={
                  msg.type === "bot"
                    ? "bot"
                    : "user"
                }
              >
                {msg.text}
              </div>

            ))}


            {/* =================================================
                OPTIONS
            ================================================= */}

            {options[step] &&
              !selectedOption && (

                <div className="options">

                  {options[step].map(
                    (item, i) => (

                      <button
                        key={i}
                        onClick={() =>
                          selectOption(item)
                        }
                      >
                        ◯ {item}
                      </button>

                    )
                  )}

                </div>

              )}

          </div>


          {/* =================================================
              INPUT
          ================================================= */}

          {!options[step] &&
            !finished && (

              <div className="inputBox">

                <input
                  value={input}

                  onChange={e =>
                    setInput(e.target.value)
                  }

                  onKeyDown={e => {

                    if (
                      e.key === "Enter"
                    ) {
                      sendMessage();
                    }

                  }}

                  placeholder="כתוב הודעה..."
                />


                <button
                  onClick={sendMessage}
                  aria-label="שליחת הודעה"
                >
                  <FaPaperPlane />
                </button>

              </div>

            )}


          {/* =================================================
              SEND WHATSAPP
          ================================================= */}

          {finished && (

            <button
              className="sendWA"
              onClick={sendWhatsapp}
            >
              שליחה לוואטסאפ 🟢
            </button>

          )}

        </div>

      )}

    </>
  );
}